import { getConfig, getReduxStore } from '../gaia-data/init';
// import amplitude from 'amplitude-js';

export var SEND_AMPLITUDE_EVENT = 'SEND_AMPLITUDE_EVENT';

// this comes from the AnalyticStandardType enum in gaia-server's events-schema
var analyticEventNames = {
  ACTIVITY_COMPLETED: 'ACTIVITY_COMPLETED',
  ACTIVITY_EXITED: 'ACTIVITY_EXITED',
  ACTIVITY_SKIPPED: 'ACTIVITY_SKIPPED',
  ACTIVITY_STARTED: 'ACTIVITY_STARTED',
  APP_CLOSED: 'APP_CLOSED',
  APP_OPENED: 'APP_OPENED',
  ASSESSMENT_END: 'ASSESSMENT_END',
  ASSESSMENT_START: 'ASSESSMENT_START',
  ASSESSMENT_STEP: 'ASSESSMENT_STEP',
  AVAILABLE_COURSES_VIEWED: 'AVAILABLE_COURSES_VIEWED',
  COURSE_ADDED: 'COURSE_ADDED',
  COURSE_REMOVED: 'COURSE_REMOVED',
  LESSON_EXITED: 'LESSON_EXITED',
  LESSON_MENU_VIEWED: 'LESSON_MENU_VIEWED',
  LESSON_STARTED: 'LESSON_STARTED',
  LESSON_SUMMARY_VIEWED: 'LESSON_SUMMARY_VIEWED',
  MESSAGES_LAUNCHED: 'MESSAGES_LAUNCHED',
  MY_COURSES_VIEWED: 'MY_COURSES_VIEWED',
  SETTINGS_OPENED: 'SETTINGS_OPENED',
  OTHER_EVENT: 'OTHER_EVENT'
};

// these come from the AnalyticEvent defined in gaia-server's events-schema
var analyticEventPropNames = {
  eventType: 'eventType',

  // non-standard events and their props
  otherEventType: 'otherEventType',
  otherEventProps: 'otherEventProps',

  activityId: 'activityId',
  activityScore: 'activityScore',
  appOpenSource: 'appOpenSource',
  appOpenType: 'appOpenType',
  appVersion: 'appVersion',
  appName: 'appName',
  courseGrade: 'courseGrade',
  courseId: 'courseId',
  errorDetail: 'errorDetail',
  errorType: 'errorType',
  failedLoginEmail: 'failedLoginEmail',
  platform: 'platform',
  screenHeight: 'screenHeight',
  screenWidth: 'screenWidth',
  sequenceId: 'sequenceId',
  sequenceScore: 'sequenceScore',
  sequenceVersion: 'sequenceVersion',
  signInMethod: 'signInMethod',
  sreVersion: 'sreVersion',
  timeSpent: 'timeSpent',
  userAgent: 'userAgent',

  // ff are just for Activity Exited event
  completedPercent: 'completedPercent',
  correct: 'correct',
  correctPercent: 'correctPercent',
  incorrect: 'incorrect',
  incorrectPercent: 'incorrectPercent',
  notSeen: 'notSeen',
  notSeenPercent: 'notSeenPercent',
  skipped: 'skipped',
  skippedPercent: 'skippedPercent',

  // ff are for assessment events only
  assessmentQuestionGuid: 'assessmentQuestionGuid',
  assessmentQuestionType: 'assessmentQuestionType',
  assessmentStepResponse: 'assessmentStepResponse',
  assessmentStepScore: 'assessmentStepScore',
  requestVersion: 'requestVersion',
  seedItem: 'seedItem',
  testLanguage: 'testLanguage',
  testResultLevel: 'testResultLevel',
  testResultScore: 'testResultScore',
  testType: 'testType',
  testVersion: 'testVersion'
};

// the entire point of using the amplitude lib and initializing the
//  user with it is to get some of the details that lib supplies, e.g.
//  Country, to be added to the user profile.  All the rest happens on gaia-server.
var amplitudeInitialized = false;
export var initAmplitudeUser = function initAmplitudeUser(userId) {
  // if (!amplitudeInitialized) {
  //   const amplitudeKey = getConfig().amplitudeKey;
  //   amplitude.getInstance().init(amplitudeKey);
  //   amplitudeInitialized = true;
  // }
  // amplitude.getInstance().setUserId(userId);
  // amplitude.getInstance().setUserProperties({ GUI: userId });
};

// this is for general use - to make it easy for components to call
var sendAmplitudeEvent = function sendAmplitudeEvent(eventName, eventProperties) {
  // since amplitude was turned off this is a no-op per CD-1178
  // getReduxStore().dispatch({
  //   type: SEND_AMPLITUDE_EVENT,
  //   payload: {
  //     eventName: eventName,
  //     eventProperties: eventProperties
  //   }
  // });
};

export var amplitudeHelper = {
  analyticEventNames: analyticEventNames,
  analyticEventPropNames: analyticEventPropNames,
  sendAmplitudeEvent: sendAmplitudeEvent
};